import { useState } from 'react';

let globalIdCounter = 0;

/**
 * Hook to generate a unique ID or use the provided one
 * @param providedId Optional ID provided by the user
 * @returns A unique ID string
 */
export function useId(providedId?: string): string {
  const [id] = useState(() => providedId || `input-${globalIdCounter++}`);
  return id;
}
